// extracted by mini-css-extract-plugin
module.exports = {"disclaimerContent":"FOMejP3y","disclaimerIcon":"_12BnmEwG","subtitle":"_38nh5M0P","itemCount":"_27LGKsBD"};